module.exports = __webpack_public_path__ + "static/media/spice_hero_twitter_card.48b272e9.jpg";